/**
 * セミナー詳細 開催日時 1:随時開催
 */
export const SEMINAR_INFORMATION_ADJUST_SCHEDULE_ANYTIME = {
    label: '随時開催',
    value: 1,
};
/**
 * セミナー詳細 開催日時 2:日程を設定する
 */
export const SEMINAR_INFORMATION_ADJUST_SCHEDULE_FIXED = {
    label: '日程を設定する',
    value: 2,
};
/**
 * セミナー詳細 開催日時
 */
export const SEMINAR_INFORMATION_ADJUST_SCHEDULES = [
    SEMINAR_INFORMATION_ADJUST_SCHEDULE_ANYTIME,
    SEMINAR_INFORMATION_ADJUST_SCHEDULE_FIXED,
];
